<spinner *ngIf="loading"></spinner>

<form [formGroup]="form">

    <div class="row" formGroupName="patient" *ngIf="['Patient', 'Patient and carer'].includes(typeOfUser)">
        <div class="col-12">
            <div class="d-flex align-items-center">
                <h6 class="mt-2 mb-0 fw-bold">Patient Information</h6>
                <app-batch-reveal-button *ngIf="patient?.user?.id"
                                         style="margin-left: 10px"
                                         [targetUserId]="patient.user.id"
                                         [fields]="['firstName', 'lastName', 'email', 'phoneNumber', 'nhsNumber']">
                </app-batch-reveal-button>
            </div>
            <hr class="mt-2 mb-4" />
        </div>

        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">First name <span class="text-red">*</span></label>
                <input type="text" class="form-control" formControlName="firstName" placeholder="Enter first name here" [class.bg-light]="patient?.user?.id && !isUnmasked"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">Last name <span class="text-red">*</span></label>
                <input type="text" class="form-control" formControlName="lastName" placeholder="Enter last name here" [class.bg-light]="patient?.user?.id && !isUnmasked"/>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">Date of birth <span class="text-red">*</span></label>
                <input #dob formControlName="dateOfBirth" type="date" class="form-control" (click)="openPicker(dob)"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">Age (Calculated) <span class="text-red">*</span></label>
                <input formControlName="age" type="number" step="1" readonly class="form-control bg-light" placeholder="Age"/>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-sex-at-birth">What was their sex at birth? <span class="text-red">*</span></label>
                <ng-select labelForId="reg-sex-at-birth" placeholder="Select one option" formControlName="sexAtBirth" [clearable]="false" [searchable]="false">
                    <ng-option [value]="'Male'">Male</ng-option>
                    <ng-option [value]="'Female'">Female</ng-option>
                </ng-select>
            </div>
        </div>
        <div class="col-md-6"></div>

        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">Mobile phone number <span class="text-red">*</span></label>
                <br>
                @if (isUnmasked || !patient?.user?.id) {
                    <ngx-intl-tel-input
                        [cssClass]="'form-control ' + (patientGroup.get('phoneNumber')?.invalid && patientGroup.get('phoneNumber')?.touched? 'is-invalid' : '') + (patient?.user?.id && !isUnmasked ? ' bg-light' : '')"
                        [separateDialCode]="true"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true"
                        [searchCountryFlag]="true"
                        [searchCountryPlaceholder]="'Search by country name or dial code (no +)'"
                        [selectFirstCountry]="true"
                        [selectedCountryISO]="'gb'"
                        [maxLength]="15"
                        [phoneValidation]="false"
                        formControlName="phoneNumber"
                    ></ngx-intl-tel-input>
                } @else {
                    <input type="text" class="form-control bg-light" formControlName="phoneNumber">
                }
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label class="form-label">Email <span *ngIf="!patientGroup.get('patientEmailUnknown').value" class="text-red">*</span></label>
                <input type="email" class="form-control" formControlName="email" placeholder="Enter email address here" [class.bg-light]="patient?.user?.id && !isUnmasked"/>
            </div>
            <div class="form-check mt-1 mb-3" *ngIf="isUnmasked || !patient?.user?.id">
                <input class="form-check-input" type="checkbox" id="patientEmailUnknown" formControlName="patientEmailUnknown" (change)="patientEmailUnknownChange()" [attr.disabled]="patient?.user?.id && !isUnmasked ? true : null">
                <label class="form-check-label" for="patientEmailUnknown">
                    Email address unknown
                </label>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">NHS number</label>
                <input type="text" class="form-control" formControlName="nhsNumber" placeholder="Enter NHS number here" [class.bg-light]="patient?.user?.id && !isUnmasked"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">NHS number (re-enter to verify)</label>
                <input type="text" class="form-control" formControlName="nhsNumber2" placeholder="Re-enter NHS number here" [class.bg-light]="patient?.user?.id && !isUnmasked"/>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group mb-1">
                <label class="form-label">Weight (kg) <span class="text-red">*</span></label>
                <input formControlName="weight" type="number" step="0.01" class="form-control" placeholder="Enter weight here"/>
            </div>
            <div class="mb-1" style="color: #4d6b7e; font-size: 14px; font-style: italic; margin-left: 15px">If not available leave 0</div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-1">
                <label class="form-label">Height (cm) <span class="text-red">*</span></label>
                <input formControlName="height" type="number" step="0.01" class="form-control" placeholder="Enter height here"/>
            </div>
            <div class="mb-1" style="color: #4d6b7e; font-size: 14px; font-style: italic; margin-left: 15px">If not available leave 0</div>
        </div>
    </div>

    <div class="row mt-4" formGroupName="carer" *ngIf="['Carer', 'Patient and carer'].includes(typeOfUser)">
        <div class="col-12">
            <div class="d-flex align-items-center">
                <h6 class="mt-2 mb-0 fw-bold">Carer Information</h6>
                <app-batch-reveal-button *ngIf="patient?.carer?.user?.id"
                                         style="margin-left: 10px"
                                         [targetUserId]="patient.carer.user.id"
                                         [fields]="['firstName', 'lastName', 'email', 'phoneNumber']">
                </app-batch-reveal-button>
            </div>
            <hr class="mt-2 mb-4" />
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">First name <span class="text-red">*</span></label>
                <input type="text" class="form-control" formControlName="carerFirstName" placeholder="First name" [class.bg-light]="patient?.carer?.user?.id && !isCarerUnmasked"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">Last name <span class="text-red">*</span></label>
                <input type="text" class="form-control" formControlName="carerLastName" placeholder="Last name" [class.bg-light]="patient?.carer?.user?.id && !isCarerUnmasked"/>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">Mobile phone number <span class="text-red">*</span></label>
                <br>
                @if (isCarerUnmasked || !patient?.carer?.user?.id) {
                    <ngx-intl-tel-input
                        [cssClass]="'form-control ' + (carerGroup.get('carerPhoneNumber')?.invalid && carerGroup.get('carerPhoneNumber')?.touched? 'is-invalid' : '') + (patient?.carer?.user?.id && !isCarerUnmasked ? ' bg-light' : '')"
                        [separateDialCode]="true"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true"
                        [searchCountryFlag]="true"
                        [searchCountryPlaceholder]="'Search by country name or dial code (no +)'"
                        [selectFirstCountry]="true"
                        [selectedCountryISO]="'gb'"
                        [maxLength]="15"
                        [phoneValidation]="false"
                        formControlName="carerPhoneNumber"
                    ></ngx-intl-tel-input>
                } @else {
                    <input type="text" class="form-control bg-light" formControlName="carerPhoneNumber">
                }
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label">Email <span *ngIf="!carerGroup.get('carerEmailUnknown').value" class="text-red">*</span></label>
                <input type="email" class="form-control" formControlName="carerEmail" placeholder="Enter email address here" [class.bg-light]="patient?.carer?.user?.id && !isCarerUnmasked"/>
            </div>
            <div class="form-check mt-1 mb-3" *ngIf="isCarerUnmasked || !patient?.carer?.user?.id">
                <input class="form-check-input" type="checkbox" id="carerEmailUnknown" formControlName="carerEmailUnknown" (change)="carerEmailUnknownChange()" [attr.disabled]="patient?.carer?.user?.id && !isCarerUnmasked ? true : null">
                <label class="form-check-label" for="carerEmailUnknown">
                    Email address unknown
                </label>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group mb-3">
                <label class="form-label" for="reg-carer-relationship">Relation to patient <span class="text-red">*</span></label>
                <ng-select labelForId="reg-carer-relationship" placeholder="Select one option" formControlName="carerRelationship" [clearable]="false" [searchable]="false">
                    @for (relationship of carerRelationshipList; track relationship) {
                        <ng-option [value]="relationship.id">{{relationship.name}}</ng-option>
                    }
                </ng-select>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3" *ngIf="shownCarerRelationshipNotes">
                <label class="form-label">Relation</label>
                <input type="text" class="form-control" formControlName="carerRelationshipNotes" placeholder="Enter the relation here"/>
            </div>
        </div>
    </div>
</form>
